export enum DeviceNotStreamableReason {
  NotAStreamableDevice = 'NOT_A_STREMABLE_DEVICE',
  LackingCorrectScope = 'LACKING_CORRECT_SCOPE',
  NotInCommandHierarchy = 'NOT_IN_COMMAND_HIERARCHY',
  UnsupportedClient = 'UNSUPPORTED_CLIENT',
  RespondFeatureFlag = 'RESPOND_FEATURE_FLAG',
  ExternalFeatureFlag = 'EXTERNAL_FEATURE_FLAG',
  ExternalNotStreamable = 'EXTERNAL_NOT_STREAMABLE',
  Offline = 'OFFLINE',
  StaleState = 'STALE_STATE',
  DeviceNotRecording = 'DEVICE_NOT_RECORDING',
  LackingConnectedDevices = 'LACKING_CONNECTED_DEVICES',
  DeviceLivestreamSettings = 'DEVICE_LIVESTREAM_SETTINGS',
  InsufficientSignal = 'INSUFFICIENT_SIGNAL',
  InsufficientOwnerBroadcastPermission = 'INSUFFICIENT_OWNER_BROADCAST_PERMISSION',
  Streamable = 'STREAMABLE',
}
